$(document).ready(function(){
  $('.content_slider_outer').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrow: false,
    dots: false,
    autoplay: true
  });
  $('.testimonial_slider_holder').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrow: false,
    dots: true,
    autoplay: true
  });
  $('.both_annou_holder').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrow: false
  });
  $('.announment_slider .slideshow-container').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    fade: true,
    arrow: false,
    dots: false,
    autoplay: true,
    prevArrow: false,
    nextArrow: false
  });
  $('.template-plan-pdp .tab-list-ul .direct ').addClass('activelink');
  $('.template-plan-pdp div#tab2').addClass('active');
   $('.template-plan-pdp div#tab2').removeClass('hide');
  $('.clickme').click(function(){
    $(this).siblings().removeClass('activelink');
    $(this).addClass('activelink');
    var tagid = $(this).children().data('tag');
    $(this).parent().siblings().find('.list').removeClass('active').addClass('hide');
    $('#'+tagid).addClass('active').removeClass('hide');
  });
  $(".set > a").on("click", function() {
    if ($(this).hasClass("active")) {
      $(this).removeClass("active");
      $(this)
      .siblings(".content")
      .slideUp(200);
      $(".set > a i")
      .removeClass("fa-minus")
      .addClass("fa-plus");
    } else {
      $(".set > a i")
      .removeClass("fa-minus")
      .addClass("fa-plus");
      $(this)
      .find("i")
      .removeClass("fa-plus")
      .addClass("fa-minus");
      $(".set > a").removeClass("active");
      $(this).addClass("active");
      $(".content").slideUp(200);
      $(this)
      .siblings(".content")
      .slideDown(200);
    }
  });
  jQuery('.custom-slider-inner').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: true,
    infinite: true,
    draggable: false,
    asNavFor: '.nav-custom-slider'
  });
  jQuery('.nav-custom-slider').slick({
    slidesToShow: 6,
    slidesToScroll: 1,
    arrows: true,
    asNavFor: '.custom-slider-inner',
    dots: false,
    autoplay: true,
    centerMode: true,
    focusOnSelect: true,
    prevArrow: '<div class="slick-prev slick-arrow"><span> ‹</span> </div>',
    nextArrow: '<div class="slick-next slick-arrow"><span> ›</span> </div>',
    responsive: [        
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1
        }
      }
    ]
  });


// banner silder 
  
  jQuery('.hero-slider-main').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    autoplay: true,
    dots: false,
    fade: false,
    infinite: true,
    prevArrow: '<div class="slick-prev slick-arrow"><span> ‹</span> </div>',
      nextArrow: '<div class="slick-next slick-arrow"><span> ›</span> </div>',
    responsive: [        
      {
        breakpoint: 600,
        settings: {
          arrows: false,
          dots: false,
        }
      }
    ]
  });
  jQuery('.hero-slider-main-mobile').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    autoplay: true,
    dots: false,
    fade: false,
    infinite: false,
    responsive: [        
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: true,
           prevArrow: '<div class="slick-prev slick-arrow"><span> ‹</span> </div>',
      nextArrow: '<div class="slick-next slick-arrow"><span> ›</span> </div>',
          dots: false,
        }
      }
    ]
   
  });



// testimonials section 
  
$('.custom_testimonails_wrapper').slick({
  dots: false,
  infinite: true,
  speed: 300,
  arrows: true,
  autoplay: true,
  prevArrow: '<div class="slick-prev slick-arrow"><span> ‹</span> </div>',
  nextArrow: '<div class="slick-next slick-arrow"><span> ›</span> </div>',
  autoplaySpeed: 6000,
  slidesToShow: 1,
  adaptiveHeight: true
});  

// logo-list 

jQuery('#mobile_slider').slick({
  slidesToShow: 3,
  slidesToScroll: 1,
  arrows: true,
  prevArrow: '<div class="slick-prev slick-arrow"><span> ‹</span> </div>',
  nextArrow: '<div class="slick-next slick-arrow"><span> ›</span> </div>',
  fade: false,
  infinite: true,
});
  
  var wWidth = jQuery(window).width();
  if(wWidth <= 600 ){
    jQuery('.three_product').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      prevArrow: '<div class="slick-prev slick-arrow"><span> ‹</span> </div>',
      nextArrow: '<div class="slick-next slick-arrow"><span> ›</span> </div>',
      fade: false,
      infinite: true,
    });
  }
  //    $(".desktop_tabs .activelink").click(function() {
  //      $('.desktop_tabs').toggleClass('expand');
  //      $('li.clickme:first').find('a').text('Description');
  //    });

  //   $(window).resize(function(e) {
  //     if ($(window).width() <= 767) {
  //    $(".actLink").click(function() {
  //      var text_a = $(this).find("a").text();     
  //      $('li.clickme:first').find('a').text(text_a).parent().addClass('activelink');
  //      $(this).parent().removeClass('expand');

  //    });
  //     }
  //   });   

  //   $("li.clickme:first").click(function() {
  //      $('.desktop_tabs').removeClass('expand');

  //    });
  
 
  
  if(localStorage.getItem('popState') != 'shown'){
    jQuery('.homepage_popup').delay(2000).fadeIn(300);
    localStorage.setItem('popState','shown')
  }
  jQuery(document).on("click", '.homepage_popup .close-btn' , function() { 
    jQuery('.homepage_popup').fadeOut(300);
  });
});



// Annoucment bar sliders 
// window.onload= function () {
//   setInterval(function(){ 
//     plusSlides(1);
//   }, 2000);
// }

// var slideIndex = 1;
// showSlides(slideIndex);
// // showSlides2(slideIndex);

// function plusSlides(n) {
//   showSlides(slideIndex += n);
// }

// function plusSlides2(n) {
//   showSlides2(slideIndex += n);
// }

// function currentSlide(n) {
//   showSlides(slideIndex = n);
//   // showSlides2(slideIndex = n);
// }

// function showSlides(n) {
//   var i;
//   var slides = document.querySelector(".mySlides");
//   // var dots = document.getElementsByClassName("dot");
//   if (n > slides.length) {slideIndex = 1}    
//   if (n < 1) {slideIndex = slides.length}
//   // for (i = 0; i < slides.length; i++) {
//   //     slides[i].style.display = "none";  
//   // }
//   // for (i = 0; i < dots.length; i++) {
//   //     dots[i].className = dots[i].className.replace(" active", "");
//   // }
//   // console.log(slideIndex-1);
//   // slides[slideIndex-1].style.display = "block";  
//   // dots[slideIndex-1].className += " active";
// }


// function showSlides2(n) {
//   var i;
//   var slides = document.getElementsByClassName("mySlides2");
//   console.log('2', slides);
//   var dots = document.getElementsByClassName("dot");
//   if (n > slides.length) {slideIndex = 1}    
//   if (n < 1) {slideIndex = slides.length}
//   for (i = 0; i < slides.length; i++) {
//       slides[i].style.display = "none";  
//   }
//   for (i = 0; i < dots.length; i++) {
//       dots[i].className = dots[i].className.replace(" active", "");
//   }
//   slides[slideIndex-1].style.display = "block";  
//   dots[slideIndex-1].className += " active";
// }


$(document).ready(function(){
  $('.ugc-review-block').slick({
      dots: false,
      arrows: true,
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      prevArrow: '<div class="slick-arrows-style slick-prev slick-arrow"><span> ‹</span> </div>',
      nextArrow: '<div class="slick-arrows-style slick-next slick-arrow"><span> ›</span> </div>'
  });
});